export const INITIAL_SPEED = 1;

export const STORAGE_KEY = "MOBIDYS_AUDIO_PLAER_SPEED";

export const SPEED_RANGE = [0.8, 1.2];
export const SPEED_STEP = 0.01;
export const SPEED_MARKS = [0.8, 0.9, 1, 1.1, 1.2];
